import { Flex, Text } from '.';
import { useCalibration } from '../../../../context/calibrationContext';

const PatientDistanceField = ({ ...props }) => {
  const {
    calibrationData: { distanceFromScreen },
  } = useCalibration();

  return (
    <Flex border='1px solid #d6e4ec' alignItems='center' backgroundColor='#fbfbfb' borderRadius='4px' padding='0.7rem 1.3rem' {...props}>
      <Text fontSize='0.875rem' width='14em'>{`Patient Distance: ${distanceFromScreen?.toFixed() || 500}mm`}</Text>
    </Flex>
  );
};

export default PatientDistanceField;
